module.exports = __webpack_public_path__ + "static/media/indique.fe6cf9c1.svg";